import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import {
  Home,
  NoPage,
  CodingClass,
  FreeTrialPage,
  DArtClass,
  GameDesignClass,
  StudentOnboard,
  PrivacyPolicy,
  TOS,
  Inclusivity,
  FAQ,
  ContactUsPage,
  AboutUs,
  Events,
} from "./pages";
import { ScrollToAnchor } from "./components";
import { ParallaxProvider } from "react-scroll-parallax";
import { Heading, NavBar, Footer } from "./components";
import TrialForm from "./pages/techtails/TrialForm";
import ZoomHowTo from "./pages/techtails/ZoomHowTo";
import PricingTool from "./pages/techtails/PricingTool";
import UFA from "./pages/techtails/scholarships/UFA";
import ESA from "./pages/techtails/scholarships/ESA";
import CFEF from "./pages/techtails/scholarships/CFEF";
import ScholarshipFunnel from "./pages/techtails/ScholarshipFunnel";
import ScholarshipAd from "./pages/techtails/ScholarshipAd";

// Layout for pages that should show the NavBar and Heading.
const MainLayout = () => (
  <>
    <NavBar />
    <div className="flex flex-col items-center">
      <Heading />
      <div className="max-w-screen-lg w-full pt-[108px]">
        <ScrollToAnchor />
        <Outlet />
      </div>
    </div>
    <Footer />
  </>
);

// Layout for scholarship pages (omitting NavBar and Heading).
const ScholarshipLayout = () => (
  <>
    <div className="max-w-screen-lg w-full pt-[108px] mx-auto">
      <ScrollToAnchor />
      <Outlet />
    </div>
    <Footer />
  </>
);

// Full-width funnel layout (no max-width, no nav — pure conversion page).
const FunnelLayout = () => (
  <>
    <div className="w-full">
      <ScrollToAnchor />
      <Outlet />
    </div>
    <Footer />
  </>
);

const App = () => {
  return (
    <ParallaxProvider>
      <div className="w-full overflow-hidden">
        <Routes>
          {/* Routes using MainLayout */}
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/pages/zoomhowto" element={<ZoomHowTo />} />
            <Route path="/pages/pricingtool" element={<PricingTool />} />
            <Route path="/pages/freetrial" element={<FreeTrialPage />} />
            <Route path="/pages/contactus" element={<ContactUsPage />} />
            <Route path="/pages/about" element={<AboutUs />} />
            <Route path="/pages/events" element={<Events />} />
            <Route path="/pages/FAQ" element={<FAQ />} />
            <Route path="/pages/learnmore/coding" element={<CodingClass />} />
            <Route path="/pages/learnmore/3dart" element={<DArtClass />} />
            <Route path="/pages/navigator" element={<Inclusivity />} />
            <Route path="/pages/onboarding" element={<StudentOnboard />} />
            <Route path="/pages/trialform" element={<TrialForm />} />
            <Route path="/pages/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/pages/termsofservice" element={<TOS />} />
            <Route path="/pages/learnmore/gamedesign" element={<GameDesignClass />} />
            <Route path="*" element={<NoPage />} />
          </Route>

          {/* Routes using ScholarshipLayout (without NavBar/Heading) */}
          <Route element={<ScholarshipLayout />}>
            <Route path="/pages/ufa" element={<UFA />} />
            <Route path="/pages/cfef" element={<CFEF />} />
            <Route path="/pages/esa" element={<ESA />} />
            <Route path="/pages/scholarships" element={<ScholarshipFunnel />} />
          </Route>

          {/* Full-width funnel pages */}
          <Route element={<FunnelLayout />}>
            <Route path="/pages/get-started" element={<ScholarshipAd />} />
          </Route>
        </Routes>
      </div>
    </ParallaxProvider>
  );
};

export default App;
